module.exports = __webpack_public_path__ + "static/media/mouton_03_thumb_hover.4ae6ef92.png";